import dataManager from '@/plugins/dataManager'

export default {
  async getCurrentUser () {
    const user = await dataManager.get('clive', 'v1/leaveManagement/user')
    return user
  },
  async getLatestAttendance () {
    const attendance = await dataManager.get('checkIn', 'attendance/latest')
    return attendance
  },
  async getSite (siteId) {
    const site = await dataManager.get('checkIn', `job/${siteId}/site`)
    return site
  },

  async checkIn (params) {
    const response = await dataManager.post('checkIn', 'checkin/check-in', params)
    return response
  },
  async checkOut (params) {
    const response = await dataManager.post('checkIn', 'checkin/check-out', params)
    return response
  },

  /**
   * Get the site ID associated with a tumbler ID, if it isn't a tumbler ID, but
   * is a site ID, it will return the site ID directly
   * @param {Guid} tumblerId
   * @returns Guid siteId
   */
  async GetTumblerSiteId (tumblerId) {
    const siteId = await dataManager.get('checkIn', `checkin/tumblerSiteId/${tumblerId}`)
    return siteId
  },

  /**
   * Submit a power reading taken from the scanned QR URL.
   *
   * Values are sent as strings so the 'n' unknown marker survives, which is what
   * lets the server tell a firmware that cannot report from a UPS that will not.
   *
   * @param {Object} params - The reading.
   * @param {Guid} params.tumblerId - Tumbler identifier from the scanned URL.
   * @param {string} params.batteryLevel - '0'-'100', or 'n' when the UPS did not answer.
   * @param {string} params.powerSource - 'e' mains, 'b' battery, or 'n' when unknown.
   * @param {string} [params.qrPayloadVersion] - The scanned URL's optional 'v'
   * parameter, forwarded as-is. Not parsed or validated here.
   * @param {string} [params.rtc] - The scanned URL's optional 'rtc' reset flag,
   * forwarded as-is. Not parsed or validated here.
   * @param {string} [params.secret] - The scanned URL's QR secret, forwarded so
   * the server can reject readings from a stale QR.
   * @returns {Promise<void>} Resolves when accepted. Callers must swallow rejections:
   * a telemetry failure is not a check-in failure and must never reach the worker.
   */
  async postTelemetry (params) {
    const response = await dataManager.post('checkIn', 'checkin/telemetry', params)
    return response
  }
}
